import { render, staticRenderFns } from "./CategoriesPage.vue?vue&type=template&id=c04f0684&scoped=true&"
import script from "./CategoriesPage.vue?vue&type=script&lang=js&"
export * from "./CategoriesPage.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesPage.vue?vue&type=style&index=0&id=c04f0684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04f0684",
  null
  
)

export default component.exports